<div style="display: flex; flex-direction: column; height: 100vh; width: 100vw">
  <header
    class="p-2 text-center custom-nav"
  >
    <div class="" >
      <div
        class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"
      >
        <a
          href="/"
          class="d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none"
        >
          <img
            src="assets/brand-logo.jpeg"
            class="bi ms-3 me-3 rounded-pill"
            [class.bg-light] = "themeService.themeState().bg === 'dark'"
            width="40"
            height="40"
            style="width:40px;"
          /><h2 class="text-dark me-5 brand-name my-auto">SaiRoadlines</h2>
        </a> 
        <ul
          class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0"
        >

       
            @if (authService.authState().user.role === 'Admin') { 
          <li >
            <a
            replaceUrl="true"
            [routerLink]="'./accounts'"
            class="btn px-2 custom-btn"
              [class]="'text-' + themeService.themeState().text"
              [routerLinkActive]="
                'btn-outline-' + themeService.themeState().text
              ">Accounts</a
            >
          </li>
          <li >
            <a
            replaceUrl="true"
            [routerLink]="'./city'"
            class="btn px-2 custom-btn"
              [class]="'text-' + themeService.themeState().text"
              [routerLinkActive]="
                'btn-outline-' + themeService.themeState().text
              "
              >City</a
            >
          </li>
        }
        
        @if (authService.authState().user.role === 'Admin') { 
        <li >
          <a
          replaceUrl="true"
          class="btn px-2 custom-btn" 
            [class]="'text-' + themeService.themeState().text"
            [routerLinkActive]="
              'btn-outline-' + themeService.themeState().text
            "
            >Reports</a
          >
        </li>
      }

      <li >
        <a
        replaceUrl="true"
        [routerLink]="'./bookings'"
        class="btn px-2 custom-btn" 
          [class]="'text-' + themeService.themeState().text"
          [routerLinkActive]="
            'btn-outline-' + themeService.themeState().text
          "
          >Bookings</a
        >
      </li>
        </ul>

        <div class="dropdown text-end">
          <a
            class="d-block link-body-emphasis text-decoration-none dropdown-toggle btn me-2"
            [class]="
              'text-' +
              themeService.themeState().text +
              ' btn-outline-' +
              themeService.themeState().text
            "
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ authService.authState()?.user?.userName }}
            <tag [value]="authService.authState()?.user?.role" classList="ms-1 bg-success" [i]="false" />
          </a>
          <ul
            class="dropdown-menu " style="width: 185px !important;"
            [class]="'dropdown-menu-' + themeService.themeState().bg"
          >
            <li>
              <div class="dropdown-item mt-1 mb-1">Web App Ver {{AppVer}}</div>
            </li>
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              <a class="dropdown-item" (click)="authService.logout()"
                ><b>Sign out</b></a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <main style="flex: 1" [class]="'text-bg-' + themeService.themeState().bg">
    <div class="bg-light p-5 rounded" *ngIf="outlet.isActivated == false">
      <h1>Welcome, {{ authService.authState()?.user?.userName }}</h1>
    </div>
    <router-outlet #outlet="outlet"></router-outlet>
  </main>
</div>
